<ng-container *transloco="let t; read: 'event-hours-table'">
  <ng-template #headerTemplate>
    <app-obj-multi-select
      [label]="t('eventType')"
      [orderedItems]="eventTypes"
      [(kvPairs)]="selectedEventTypes"
      (kvPairsChange)="getData()"
    ></app-obj-multi-select>
  </ng-template>

  <div [appLoading]="loading">
    <app-data-table
      [actionsTemplate]="headerTemplate"
      [cols]="cols"
      [loading]="loading"
      [selectedCols]="cols"
      [tableRows]="tableRows$"
      [translationScope]="'event-hours-table'"
    >
    </app-data-table>
  </div>
</ng-container>
